module.exports = "<div class=\"messages\">\r\n    <div\r\n         *ngFor=\"let message of messages\"\r\n         (click)=\"hideMessage(message)\"\r\n         [ngClass]=\"{\r\n            'alert': true,\r\n            'alert-success': message.type == 1,\r\n            'alert-danger': message.type == 2\r\n         }\"\r\n    >\r\n        <p>{{ message.title }}</p>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/front/core/notifications/notifications.component.html
// module id = 579
// module chunks = 1